<template>
  <div class="newsletter-register">
    <fn-section
      constrained="l"
      background-color="sand-light"
      padding-top="xs"
      padding-bottom="xs"
    >
      <fn-breadcrumbs :nodes="page?.content?.breadcrumbs" />
    </fn-section>

    <fn-section
      constrained="l"
      background-color="sand-light"
      padding-top="xs"
      padding-bottom="xs"
    >
      <div
        v-if="!showConfirmation"
        class="nr-content"
      >
        <fn-grid>
          <fn-grid-item columns="12">
            <fn-cms-section-loader
              v-if="page?.content?.content_slots?.a?.sections"
              :sections="page.content.content_slots.a.sections"
            />
          </fn-grid-item>
          <fn-grid-item
            class="nrs-content"
            columns="12"
            columns-m="6"
            push-m="3"
          >
            <fn-cms-section-loader
              v-if="page?.content?.content_slots?.b?.sections"
              :sections="page.content.content_slots.b.sections"
            />
          </fn-grid-item>
        </fn-grid>
      </div>
      <fn-newsletter-confirmation-section
        v-else
        :newsletter="newsletter"
        :image="'//placehold.it/450x240/CDBD90?text=Confirmation'"
      />
    </fn-section>

    <fn-cms-section-loader
      v-if="page.content.content_slots.c && page.content.content_slots.c.sections"
      :sections="page.content.content_slots.c.sections"
    />
  </div>
</template>

<script>
export default defineComponent({
  props: {
    page: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState(useNewsletterStore, {
      newsletter: 'newsletterSubscription',
    }),
    ...mapWritableState(useNewsletterStore, {
      showConfirmation: 'showConfirmation',
    }),
  },
});
</script>

<style lang="scss" scoped>
.newsletter-register {
  .nr-content {
    background: $color-general-background-neutral-default;
    border-radius: map-get($border-radiuses, 'l');
    overflow: hidden;
    padding-bottom: $space;
  }
}
</style>
